import type { Address } from "@shopify/address";
import AddressFormatter from "@shopify/address";
import { useQuery } from "@tanstack/react-query";

export const useFormatAddressQuery = ({
  address,
  locale,
}: {
  address: Address;
  locale: string;
}) => {
  const data = useQuery({
    queryKey: ["formatAddress", address, locale],
    queryFn: async () => {
      const addressFormatter = new AddressFormatter(locale);
      return await addressFormatter.format(address);
    },
  });

  return data;
};
